import Control from "sap/ui/core/Control";
import { MetadataOptions } from "sap/ui/core/Element";
import CameraRenderer from "./CameraRenderer";
import MessageBox from "sap/m/MessageBox";
import JSONModel from "sap/ui/model/json/JSONModel";

/**
 * @name com.unitrade.crm.camera.Camera
 */
export default class Camera extends Control {
  private _oVideo: HTMLVideoElement;
  private _stream: MediaStream;

  // The following three lines were generated and should remain as-is to make TypeScript aware of the constructor signatures
  constructor(idOrSettings?: string | $CameraSettings);
  constructor(id?: string, settings?: $CameraSettings);
  constructor(id?: string, settings?: $CameraSettings) {
    super(id, settings);
  }
  static readonly metadata: MetadataOptions = {
    properties: {},
    events: {
      snapshot: {},
    },
  };

  private _getVideo = () => {
    return jQuery("video", jQuery("#" + this.getId())).get(0) as HTMLVideoElement;
  };

  public takePicture = async (): Promise<Blob> => {
    this._oVideo.pause();
    const { width, height } = this._stream.getTracks()[0].getSettings();
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const context = canvas.getContext("2d");
    let oImageData: Blob = null;

    if (width && height) {
      context.drawImage(this._oVideo, 0, 0, width, height);
      oImageData = await new Promise((resolve) => canvas.toBlob(resolve, "image/jpeg"));
    }

    return oImageData;
  };

  getVideoHeight(): number {
    const { height } = this._stream.getTracks()[0].getSettings();
    return height;
  }

  getVideoWidth(): number {
    const { width } = this._stream.getTracks()[0].getSettings();
    return width;
  }

  async onAfterRendering(oEvent: JQuery.Event): Promise<void> {
    try {
      this._oVideo = this._getVideo();

      if (this._oVideo && !this._oVideo.onclick) {
        this._oVideo.onclick = () => {
          this._oVideo.paused ? this._oVideo.play() : this._oVideo.pause();
          //this._takePicture();
        };
      }

      const stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: "environment" },
        audio: false,
      });
      this._stream = stream;
      this._oVideo.srcObject = this._stream;
      this._oVideo.play();
    } catch (ex: any) {
      MessageBox.error("Problem beim Kamerazugriff:" + ex);
    }
  }

  async dispose(): Promise<void> {
    this._stream.getTracks().forEach((t) => t.stop());
    this._oVideo.pause();
    this._oVideo.removeAttribute("src");
    this._oVideo.load();
  }

  static renderer: typeof CameraRenderer = CameraRenderer;
}
